import { numberDetailsAPI } from './api';

export const MAX_PRICING_VISIBILITY = {
	OPT_IN: 'OPT_IN',
} as const;

export const MAX_PRICING_BUSINESS_ENROLLMENT = {
	ENROLLED: 'ENROLLED',
	NOT_ENROLLED: 'NOT_ENROLLED',
	UNKNOWN: 'UNKNOWN',
} as const;

export interface MaxPricingEnrollmentDetails {
	businessId?: string;
	partnerEnrollment?: boolean;
	businessEnrollment?: { status?: string };
	wabaId?: string;
	managerVisibility?: string;
	visibility?: string;
	lastSuccessfulSyncAt?: string;
	stale?: boolean;
	source?: string;
	refreshError?: { code?: string };
}

export interface MaxPricingResponse<T> {
	data?: T & { responseObject?: T };
	responseObject?: T;
}

export const unwrapMaxPricingResponse = <T>(response?: MaxPricingResponse<T>): T | undefined =>
	response?.data?.responseObject ?? response?.data ?? response?.responseObject;

export const isMaxPricingEnabled = (details?: MaxPricingEnrollmentDetails): boolean =>
	details?.partnerEnrollment === true &&
	details?.businessEnrollment?.status === MAX_PRICING_BUSINESS_ENROLLMENT.ENROLLED &&
	(details?.managerVisibility ?? details?.visibility) === MAX_PRICING_VISIBILITY.OPT_IN;

export const isMaxPricingEligible = (details?: MaxPricingEnrollmentDetails): boolean =>
	details?.partnerEnrollment === true;

export const isMaxPricingSupported = (details?: MaxPricingEnrollmentDetails): boolean =>
	details?.partnerEnrollment === true;

export async function getMaxPricingEnrollment(metaWabaId: string): Promise<MaxPricingEnrollmentDetails | undefined> {
	const response: MaxPricingResponse<MaxPricingEnrollmentDetails> =
		await numberDetailsAPI.getMaxPricingEnrollment(metaWabaId);

	return unwrapMaxPricingResponse(response);
}
